<template>
    <div id="reviews">
        <h2 class="text-xl font-bold">Відгуки</h2>
        <h3 class="mb-3 font-black text-sm text-gray-500">про товар {{ product.title }}</h3>

        <Modal v-if="comment" title="Твій коментар" :show="showCommentViewModal" @close="showCommentViewModal = false">
            <CommentItem :product="product" :review="comment" :show-reply="false" />
            <ReplyForm class="mt-5" :review="comment" @closeModal="showCommentViewModal = false" />
        </Modal>

        <div class="section p-4">
            <div v-if="product.rating && totalCount" class="mb-5 flex">
                <Rating :rating="product.rating" />

                <div rel="schema:aggregateRating">
                    <div typeof="schema:AggregateRating">
                        <div property="schema:reviewCount" :content="totalCount"></div>
                        <div property="schema:ratingValue" :content="product.rating"></div>
                    </div>
                </div>

                <Message class="w-4 mr-1.5" :class="{'ml-1.5': product.rating}" />
                {{ totalCount }}
            </div>

            <div v-if="reviews.length" class="flex items-center font-bold justify-between md:border-2 md:p-3">
                <p class="hidden md:block">Залиште відгук про цей товар</p>

                <PrimaryButton class="md:max-w-48" color="indigo" @click="showCommentModal = true">
                    Залишити відгук
                </PrimaryButton>
            </div>

            <div v-else-if="!successMessage">
                <h3 class="md:text-lg font-bold mb-5 text-center">Будь першим, залиш відгук про товар</h3>

                <div class="flex justify-center">
                    <PrimaryButton class="max-w-48" color="indigo" @click="showCommentModal = true">
                        Залишити відгук
                    </PrimaryButton>
                </div>
            </div>

            <Modal title="Залишити відгук" :show="showCommentModal" @close="showCommentModal = false">
                <CommentsForm
                  :product="product"
                  @sent="showCommentModal = false"
                />
            </Modal>

            <div v-if="successMessage" class="text-center space-y-3">
                <div class="flex justify-center">
                    <div class="w-14 bg-green-500 p-3.5 rounded-full">
                        <Check />
                    </div>
                </div>
                <p class="font-bold">Дякуємо, відгук отримано!</p>
                <p class="text-sm">Скоро він пройде модерацію і буде опублікований для усіх, якщо все ок 😉</p>

                <div class="flex justify-center">
                    <PrimaryButton class="max-w-48" @click="successMessage = false">Написати ще</PrimaryButton>
                </div>
            </div>

            <div v-if="reviews.length" class="space-y-5 mt-5" rel="schema:review">
                <CommentItem v-for="review in reviews" :product="product" :review="review" />

                <div class="flex justify-center">
                    <PrimaryButton v-if="page <= lastPage" @click="loadComments" :loading="loading" class="max-w-48">
                        Показати ще
                    </PrimaryButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PrimaryButton from '@/Components/PrimaryButton.vue';
import InputLabel from '@/Components/InputLabel.vue';
import TextInput from '@/Components/TextInput.vue';
import Star from '@/Components/Svg/Star.vue';
import Textarea from '@/Components/Forms/Textarea.vue';
import PhoneInput from '@/Components/PhoneInput.vue';
import InputError from '@/Components/InputError.vue';
import Check from '@/Components/Svg/Check.vue';
import Modal from '@/Components/Modal.vue';
import CommentsForm from '@/Partials/Products/Comments/CommentsForm.vue';
import Rating from '@/Components/Products/Rating.vue';
import Pagination from '@/Components/Pagination.vue';
import { router } from '@inertiajs/vue3';
import Message from '@/Components/Svg/Message.vue';
import CommentReply from '@/Partials/Products/Comments/CommentReply.vue';
import CommentItem from '@/Partials/Products/Comments/CommentItem.vue';
import ReplyForm from '@/Partials/Products/Comments/ReplyForm.vue';

export default {
    components: {
        ReplyForm,
        CommentItem,
        CommentReply,
        Message,
        Pagination,
        Rating,
        CommentsForm,
        Modal, Check, InputError, PhoneInput, Textarea, Star, TextInput, InputLabel, PrimaryButton
    },
    props: {
        product: Object,
        reviewsData: Object,
        comment: Object,
    },
    data() {
        return {
            reviews: this.reviewsData.data,
            successMessage: false,
            showCommentModal: false,
            page: 2,
            lastPage: this.reviewsData.meta.last_page,
            loading: false,
            totalCount: this.reviewsData.meta.total,

            showCommentViewModal: true,
        };
    },
    methods: {
        loadComments() {
            this.loading = true;

            router.reload({
                data: { page: this.page },
                only: ['reviews'],
                headers: { 'x-inertia-preserve-url': true },
                onSuccess: (response) => {
                    this.loading = false;
                    this.page++;

                    this.reviews.push(...response.props.reviews.data);
                }
            });
        }
    }
};
</script>
